import Repository from '../Repository';

const url = '/livestream/announcements';

export default {
    getUpcoming() {
        return Repository.get(`${url}/upcoming`);
    },
}
